import {Component, HostListener, inject, Inject, OnInit} from '@angular/core';
import {StatisticsService} from "../service/statistics.service";
import {AuthService} from "../service/auth.service";
import {UserService} from "../service/user.service";

@Component({
    selector: 'app-sidebar-component',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {

    public statisticService = inject(StatisticsService);
    public authService = inject(AuthService);
    public userService = inject(UserService);

    constructor(@Inject('PRODUCTION') public PRODUCTION: boolean) {
    }

    ngOnInit() {
        this.userService.getLoggedUser();
        if (this.authService.isAdmin()) {
            this.userService.getAllUsers();
        }
    }

    isAdmin() {
        return this.authService.isAdmin();
    }

    closeMobileNav() {
        if (this.isSmallScreen()) {
            this.statisticService.openNavbarMenu();
        }
    }

    @HostListener('window:resize')
    isSmallScreen(): boolean {
        return window.innerWidth <= 1115;
    }

}
